<template>
  <div>
    <v-row no-gutters>
      <v-col cols="12">
        <h1 class="headline font-weight-light mb-3">
          Pending Approved
        </h1>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" v-if="data_mileage.length">
        <v-card>
          <v-card-title>
            Mileage
            <v-btn
              fab
              small
              :color="chk_export == false ? 'green accent-3' : ''"
              class="ml-3"
              @click="export_data('mileage')"
            >
              <img
                v-if="chk_export == true"
                src="../../assets/all/Loading.gif"
                style="width:5%; "
              />
              <v-icon v-if="chk_export == false" color="teal darken-4"
                >mdi-file-excel</v-icon
              >
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn icon @click="show = !show">
              <v-icon>{{
                show ? "mdi-chevron-up" : "mdi-chevron-down"
              }}</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-subtitle>
            <!-- <span class="red--text font-fix-11">xxx</span> -->
          </v-card-subtitle>
          <v-expand-transition>
            <div v-show="show">
              <v-row>
                <v-col cols="12">
                  <v-simple-table class="table-inv">
                    <template v-slot:default>
                      <thead>
                        <tr class="col-tr-1">
                          <th class="text-center">
                            #
                          </th>
                          <th class="text-center">
                            Name
                          </th>
                          <th class="text-center">
                            Paycode
                          </th>
                          <th class="text-center">
                            Status
                          </th>
                          <th class="text-center">
                            Log
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(row, index) in data_mileage" :key="index">
                          <td class="text-center">{{ index + 1 }}.</td>
                          <td>
                            <v-btn
                              text
                              class="btn-detail"
                              @click="
                                view_emp(
                                  row.emp_id,
                                  row.emp_name_en,
                                  'mileage',
                                  row.tl,
                                  row.paycode
                                )
                              "
                              >{{ row.emp_name }}</v-btn
                            >
                          </td>
                          <td class="text-center">
                            {{ row.paycode }}
                          </td>
                          <td class="text-center">
                            <v-btn-toggle rounded>
                              <v-tooltip top>
                                <template
                                  v-slot:activator="{
                                    on,
                                  }"
                                >
                                  <v-btn
                                    small
                                    v-on="on"
                                    :color="
                                      row.requested_status === 'not approve'
                                        ? 'yellow darken-1'
                                        : row.requested_status === null
                                        ? 'blue-grey darken-2'
                                        : 'green accent-3'
                                    "
                                  >
                                    CE
                                  </v-btn>
                                </template>
                                <span>{{ row.requested_date }}</span>
                              </v-tooltip>

                              <v-tooltip top>
                                <template
                                  v-slot:activator="{
                                    on,
                                  }"
                                >
                                  <v-btn
                                    small
                                    v-on="on"
                                    :color="
                                      chk_approve_color(
                                        row.requested_status,
                                        1,
                                        row.head_status
                                      )
                                    "
                                  >
                                    TL
                                  </v-btn>
                                </template>
                                <span>{{ row.head_date }}</span>
                              </v-tooltip>

                              <v-tooltip top>
                                <template
                                  v-slot:activator="{
                                    on,
                                  }"
                                >
                                  <v-btn
                                    v-on="on"
                                    small
                                    :color="
                                      chk_approve_color(
                                        row.requested_status,
                                        2,
                                        row.mgr_status
                                      )
                                    "
                                  >
                                    MGR
                                  </v-btn>
                                </template>
                                <span>{{ row.mgr_date }}</span>
                              </v-tooltip>

                              <v-tooltip top>
                                <template
                                  v-slot:activator="{
                                    on,
                                  }"
                                >
                                  <v-btn
                                    v-on="on"
                                    small
                                    :color="
                                      chk_approve_color(
                                        row.requested_status,
                                        3,
                                        row.md_status
                                      )
                                    "
                                  >
                                    MD
                                  </v-btn>
                                </template>
                                <span>{{ row.md_date }}</span>
                              </v-tooltip>
                            </v-btn-toggle>
                          </td>
                          <td class="text-center">
                            <v-btn
                              small
                              color="white"
                              class="primary--text"
                              v-if="row.logs.length > 0"
                              rounded
                              @click="open_log(row.logs)"
                            >
                              <v-icon left small>mdi-magnify</v-icon>
                              View Approve Log
                            </v-btn>
                          </td>
                        </tr>
                        <br />
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-col>
              </v-row>
            </div>
          </v-expand-transition>
        </v-card>
      </v-col>

      <v-col cols="12" v-if="data_ot.length">
        <v-card>
          <v-card-title>
            OT
            <v-btn
              fab
              small
              :color="chk_export_ot == false ? 'green accent-3' : ''"
              class="ml-3"
              @click="export_data('ot')"
            >
              <img
                v-if="chk_export_ot == true"
                src="../../assets/all/Loading.gif"
                style="width:5%; "
              />
              <v-icon v-if="chk_export_ot == false" color="teal darken-4"
                >mdi-file-excel</v-icon
              >
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn icon @click="show2 = !show2">
              <v-icon>{{
                show2 ? "mdi-chevron-up" : "mdi-chevron-down"
              }}</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-subtitle> </v-card-subtitle>
          <v-expand-transition>
            <div v-show="show2">
              <v-row>
                <v-col cols="12">
                  <v-simple-table class="table-inv">
                    <template v-slot:default>
                      <thead>
                        <tr class="col-tr-1">
                          <th class="text-center">
                            #
                          </th>
                          <th class="text-center">
                            Name
                          </th>
                          <th class="text-center">
                            Paycode
                          </th>
                          <th class="text-center">
                            Status
                          </th>
                          <th class="text-center">
                            Log
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(row_ot, index_ot) in data_ot"
                          :key="index_ot"
                        >
                          <td class="text-center">{{ index_ot + 1 }}.</td>
                          <td>
                            <v-btn
                              text
                              class="btn-detail"
                              @click="
                                view_emp(
                                  row_ot.emp_id,
                                  row_ot.emp_name,
                                  'ot',
                                  row_ot.tl,
                                  row_ot.paycode
                                )
                              "
                              >{{ row_ot.emp_name }}</v-btn
                            >
                          </td>
                          <td class="text-center">
                            {{ row_ot.paycode }}
                          </td>
                          <td class="text-center">
                            <v-btn-toggle rounded>
                              <v-tooltip top>
                                <template
                                  v-slot:activator="{
                                    on,
                                  }"
                                >
                                  <v-btn
                                    small
                                    v-on="on"
                                    :color="
                                      row_ot.requested_status === 'not approve'
                                        ? 'yellow darken-1'
                                        : row_ot.requested_status === null
                                        ? 'blue-grey darken-2'
                                        : 'green accent-3'
                                    "
                                  >
                                    CE
                                  </v-btn>
                                </template>
                                <span>{{ row_ot.requested_date }}</span>
                              </v-tooltip>

                              <v-tooltip top>
                                <template
                                  v-slot:activator="{
                                    on,
                                  }"
                                >
                                  <v-btn
                                    small
                                    v-on="on"
                                    :color="
                                      chk_approve_color(
                                        row_ot.requested_status,
                                        1,
                                        row_ot.head_status
                                      )
                                    "
                                  >
                                    TL
                                  </v-btn>
                                </template>
                                <span>{{ row_ot.head_date }}</span>
                              </v-tooltip>

                              <v-tooltip top>
                                <template
                                  v-slot:activator="{
                                    on,
                                  }"
                                >
                                  <v-btn
                                    v-on="on"
                                    small
                                    :color="
                                      chk_approve_color(
                                        row_ot.requested_status,
                                        2,
                                        row_ot.mgr_status
                                      )
                                    "
                                  >
                                    MGR
                                  </v-btn>
                                </template>
                                <span>{{ row_ot.mgr_date }}</span>
                              </v-tooltip>

                              <v-tooltip top>
                                <template
                                  v-slot:activator="{
                                    on,
                                  }"
                                >
                                  <v-btn
                                    v-on="on"
                                    small
                                    :color="
                                      chk_approve_color(
                                        row_ot.requested_status,
                                        3,
                                        row_ot.md_status
                                      )
                                    "
                                  >
                                    MD
                                  </v-btn>
                                </template>
                                <span>{{ row_ot.md_date }}</span>
                              </v-tooltip>
                            </v-btn-toggle>
                          </td>
                          <td class="text-center">
                            <v-btn
                              small
                              color="white"
                              class="primary--text"
                              v-if="row_ot.logs.length > 0"
                              rounded
                              @click="open_log(row_ot.logs)"
                            >
                              <v-icon left small>mdi-magnify</v-icon>
                              View Approve Log
                            </v-btn>
                          </td>
                        </tr>
                        <br />
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-col>
              </v-row>
            </div>
          </v-expand-transition>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog v-model="dialogLog" width="500">
      <v-card>
        <v-card-title class="subtitle-1 primary--text">
          APPROVE LOG
        </v-card-title>
        <v-card-text>
          <v-row v-for="(log, idx) in data_log" :key="idx">
            <v-col cols="6">
              <b
                >{{ log.log_date }}
                -
                {{ log.log_name }}
              </b>
            </v-col>
            <v-col cols="6">
              {{ log.log_note }}
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialogLog = false">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <div class="text-center">
      <v-dialog v-model="dialog" class="mx-auto" max-width="375">
        <v-card>
          <v-card-text>
            <div v-if="chk_member == true">
              <br />
              <v-progress-linear
                color="orange accent-4"
                indeterminate
              ></v-progress-linear>
            </div>

            <div v-if="chk_member == false">
              <v-row>
                <v-col cols="12" class="text-center">
                  <img
                    :src="url_pic + member.img"
                    :alt="member.name"
                    width="50%"
                  />
                </v-col>
                <v-col cols="12" class="mar-t-20 text-center">
                  <span class="fix-das-bb">{{ member.name }}</span>
                  <br />
                  {{ member.team }}
                </v-col>

                <v-col cols="12" class="text-center mar-t-10">
                  <div v-for="(row_e, index_e) in member.data" :key="index_e">
                    <v-list-item class="mar-t-10">
                      <v-list-item-title class="text-center">
                        <span class="fix-das-bb">{{ row_e.paycode }}</span>
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item class="mar-t-20">
                      <v-list-item-subtitle class="text-center">
                        <v-chip small>{{
                          row_e.sum_currency + " THB."
                        }}</v-chip>
                        <v-chip small class="ml-2 mr-2">{{
                          row_e.sum_km + " Km."
                        }}</v-chip>
                        <v-chip small>{{ row_e.volume_job + " Job." }}</v-chip>
                      </v-list-item-subtitle>
                    </v-list-item>
                  </div>
                </v-col>
              </v-row>
            </div>
          </v-card-text>

          <v-divider v-if="chk_member == false"></v-divider>

          <v-card-actions v-if="chk_member == false">
            <v-spacer></v-spacer>
            <v-btn
              small
              class="btn-detail mt-1 mb-1"
              text
              @click="func_approve('mileage')"
            >
              View More
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogLog" width="500">
        <v-card>
          <v-card-title class="subtitle-1 primary--text">
            APPROVE LOG
          </v-card-title>
          <v-card-text>
            <v-row v-for="(log, idx) in data_log" :key="idx">
              <v-col cols="6">
                <b
                  >{{ log.log_date }}
                  -
                  {{ log.log_name }}
                </b>
              </v-col>
              <v-col cols="6">
                {{ log.log_note }}
              </v-col>
            </v-row>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="dialogLog = false">
              Close
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>

    <v-dialog v-model="dialog2" class="mx-auto" max-width="375">
      <v-card>
        <v-card-text>
          <div v-if="chk_member == true">
            <br />
            <v-progress-linear
              color="orange accent-4"
              indeterminate
            ></v-progress-linear>
          </div>

          <div v-if="chk_member == false">
            <v-row>
              <v-col cols="12" class="text-center">
                <img
                  :src="url_pic + member.img"
                  :alt="member.name"
                  width="50%"
                />
              </v-col>
              <v-col cols="12" class="mar-t-20 text-center">
                <span class="fix-das-bb">{{ member.name }}</span>
                <br />
                {{ member.team }}
              </v-col>

              <v-col cols="12" class="text-center mar-t-10">
                <div v-for="(row_e, index_e) in member.data" :key="index_e">
                  <v-list-item class="mar-t-10">
                    <v-list-item-title class="text-center">
                      <span class="fix-das-bb">{{ row_e.paycode }}</span>
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item class="mar-t-20">
                    <v-list-item-subtitle class="text-center">
                      <v-chip small>{{ "x1.0 : " + row_e.x10 }}</v-chip>
                      <v-chip small class="ml-2 mr-2">{{
                        "x1.5 : " + row_e.x15
                      }}</v-chip>
                      <v-chip small>{{ "x3.0 : " + row_e.x30 }}</v-chip>
                    </v-list-item-subtitle>
                  </v-list-item>
                </div>
              </v-col>
            </v-row>
          </div>
        </v-card-text>

        <v-divider v-if="chk_member == false"></v-divider>

        <v-card-actions v-if="chk_member == false">
          <v-spacer></v-spacer>
          <v-btn
            small
            class="btn-detail mt-1 mb-1"
            text
            @click="func_approve('ot')"
          >
            View More
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <back-to-top bottom="50px" right="50px">
      <v-btn small fab color="deep-purple lighten-2">
        <v-icon style="color:#FFF">mdi-chevron-up</v-icon>
      </v-btn>
    </back-to-top>
  </div>
</template>
<script>
import axios from "axios";

const url = `${process.env.VUE_APP_ROOT_API}/api/`;
export default {
  beforeMount() {
    this.tk = {
      headers: { Authorization: "Bearer " + localStorage.token },
    };
  },
  mounted() {
    this.get_data();
  },
  methods: {
    async get_data() {
      await axios
        .get(url + "expense/pending-approve", this.tk)
        .then((response) => {
          this.data_mileage = response.data.mileage;
          if (this.data_mileage.length > 0) {
            this.show = true;
          }
          this.data_ot = response.data.ot;
          if (this.data_ot.length > 0) {
            this.show2 = true;
          }
        });
    },
    async view_emp(empId, name, st, tl, paycodex) {
      this.chk_member = true;
      this.emp_id = empId;
      this.tl_id = tl;
      this.paycode = paycodex;
      this.member.name = name;
      let url2;
      if (st == "ot") {
        url2 = "ot-approve/view-detail/";
        this.dialog2 = true;
      } else {
        url2 = "mileage-approve/view-detail/";
        this.dialog = true;
      }

      await axios
        .get(url + url2 + this.emp_id)
        .then((response) => {
          this.chk_member = false;
          this.member.img = response.data.file_store_name;
          this.member.team = response.data.team_name;
          this.member.data = response.data.expenses;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    open_log(data) {
      this.data_log = data;
      this.dialogLog = true;
    },
    func_approve(st) {
      let routeData;
      if (st == "ot") {
        routeData = this.$router.resolve({
          path: "/OT/" + this.emp_id,
          query: { p: this.paycode },
        });
      } else {
        routeData = this.$router.resolve({
          path: "/Expense/Mileage/Tl/all/" + this.emp_id,
          query: { q: this.tl_id, p: this.paycode },
        });
      }

      window.open(routeData.href, "_blank");
    },
    async export_data(st) {
      if (st == "ot") {
        this.chk_export_ot = true;
      } else {
        this.chk_export = true;
      }

      await axios({
        url: `${process.env.VUE_APP_ROOT_API}/api/expense/pending-export`,
        method: "POST",
        responseType: "blob",
        data: {
          type: st,
        },
        headers: { Authorization: "Bearer " + localStorage.token },
      }).then((response) => {
        this.chk_export = false;
        this.chk_export_ot = false;
        let fileURL = window.URL.createObjectURL(new Blob([response.data]));
        let fileLink = document.createElement("a");

        fileLink.href = fileURL;
        fileLink.setAttribute("download", "file.xlsx");
        document.body.appendChild(fileLink);

        fileLink.click();
      });
    },
    chk_approve_color(st, n, st2) {
      if (n === 1) {
        if (st === "request") {
          return "yellow darken-1";
        } else if (st === "head approve" || st2 === "approve") {
          return "green accent-3";
        } else if (st2 === "not approve") {
          return "red accent-2";
        } else {
          return "blue-grey darken-2";
        }
      } else if (n === 2) {
        if (st === "head approve") {
          return "yellow darken-1";
        } else if (st === "mgr approve" || st2 === "approve") {
          return "green accent-3";
        } else if (st2 === "not approve") {
          return "red accent-2";
        } else {
          return "blue-grey darken-2";
        }
      } else if (n === 3) {
        if (st === "mgr approve") {
          return "yellow darken-1";
        } else if (st === "md approve" || st2 === "approve") {
          return "green accent-3";
        } else if (st2 === "not approve") {
          return "red accent-2";
        } else {
          return "blue-grey darken-2";
        }
      }
    },
  },
  data() {
    return {
      tk: null,
      data_mileage: [],
      data_ot: [],
      data_log: [],
      show: false,
      show2: false,
      dialog: false,
      dialog2: false,
      dialogLog: false,
      chk_member: false,
      member: {
        name: null, //localStorage.fullname,
        team: null,
        img: null, // img: localStorage.emp_img,
        data: [],
      },
      tl_id: "",
      paycode: "",
      url_pic: `${process.env.VUE_APP_ROOT_API}/api/profile_img/`,
      chk_export: false,
      chk_export_ot: false,
    };
  },
};
</script>
<style scoped>
.btn-detail {
  font-size: 14px;
  /* font-weight: bold; */
  /* color: #fff;
    background-color: #3e6d87; */
}
.btn-detail:hover {
  color: #fffb00 !important;
  background-color: #0c374e !important;
}
</style>
